import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useSubscription } from '@/hooks/useSubscription';

export default function BillingReturn() {
  const { user, loading: authLoading } = useAuth();
  const { isActive, loading: subLoading } = useSubscription();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get('session_id');

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/signin', { replace: true });
    }
  }, [user, authLoading, navigate]);

  useEffect(() => {
    if (isActive) {
      const t = setTimeout(() => navigate('/inventory', { replace: true }), 800);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [isActive, navigate]);

  return (
    <div className="app">
      <div className="main">
        <div style={{ maxWidth: 560, margin: '60px auto', textAlign: 'center' }}>
          <div className="eyebrow">Checkout · Returning From Stripe</div>
          <h1 className="h-display" style={{ fontSize: 56 }}>
            {isActive ? 'You\'re in.' : 'Finishing up…'}
          </h1>
          {isActive ? (
            <>
              <p className="lead" style={{ margin: '0 auto 24px' }}>
                Subscription is active. Redirecting to your account.
              </p>
            </>
          ) : (
            <>
              <p className="lead" style={{ margin: '0 auto 24px' }}>
                Stripe confirmed payment. Waiting for the webhook to flip your subscription to
                active — this usually takes a second or two. If it stalls, refresh the page.
              </p>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.2em', color: 'var(--gold)' }}>
                ◊ ◊ ◊
              </div>
              {sessionId && (
                <div style={{ marginTop: 28, fontFamily: 'var(--mono)', fontSize: 10, color: 'var(--text-muted)', letterSpacing: '0.1em' }}>
                  session_id: {sessionId.slice(0, 14)}…
                </div>
              )}
            </>
          )}
          {subLoading && !isActive && (
            <div style={{ marginTop: 16, fontSize: 12, color: 'var(--text-muted)' }}>
              Listening for subscription updates…
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
